<template>
  <div v-if="ratingValue" class="risk-assessment-rating">
    <v-row>
      <v-col cols="12" class="form-label safe-trip-font">
        {{ headingLabel }}
        <div
          v-if="headingLabel === 'CompliSpace Safe Excursions Recommended Rating'"
          class="confirmation-info-text"
        >
          <v-icon>fa:fas fa-info-circle</v-icon>
          <span
            >Based on the CompliSpace Risk Assessment Guide available
            <a
              id="risk-rating-summary--risk-assessment-guide--link"
              :href="riskAccessmentGuidePdf"
              class="link-primary"
              target="_blank"
              >here</a
            >.</span
          >
        </div>
        <stb-icon-tooltip
          v-if="tooltipBubbleTextDisplayed"
          icon-id="mdi-information"
          clickable
          location="end"
        >
          <div style="color: #ffffff">
            {{ tooltipBubbleText }}
          </div>
        </stb-icon-tooltip>
      </v-col>
    </v-row>
    <v-card class="p2" color="#eeeeee" style="box-sizing: content-box">
      <v-row>
        <v-col class="assessment-title"> Likelihood </v-col>
        <v-col class="assessment-value">
          <v-chip class="ma-2" :color="ratingBgColor" variant="flat" label>
            {{ likelihoodValue }}
          </v-chip>
        </v-col>
        <v-col class="assessment-title"> Consequence </v-col>
        <v-col class="assessment-value">
          <v-chip class="ma-2" :color="ratingBgColor" variant="flat" label>
            {{ consequenceValue }}
          </v-chip>
        </v-col>
        <v-col class="assessment-title"> Rating </v-col>
        <v-col class="assessment-value">
          <v-chip class="ma-2" :color="ratingBgColor" variant="flat" label>
            {{ ratingValue }}
          </v-chip>
        </v-col>
        <v-col class="rating-space"></v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import StbIconTooltip from '@/components/StbIconTooltip';

export default {
  components: { StbIconTooltip },
  props: {
    headingLabel: { type: String, required: true },
    tooltipBubbleText: { type: String, required: true },
    riskRatingRefname: { type: String, required: true }
  },

  data() {
    return {
      riskAccessmentGuidePdf: '/pdf/Risk_Assessment_Guide.pdf',
      riskRatingTemplateHash: {
        L: {
          bgColor: 'green',
          textColor: '#ffffff',
          ratingValue: 'Low'
        },
        M: {
          bgColor: 'yellow',
          textColor: '#000000',
          ratingValue: 'Medium'
        },
        H: {
          bgColor: '#ff7f32',
          textColor: '#ffffff',
          ratingValue: 'High'
        },
        E: {
          bgColor: 'red',
          textColor: '#ffffff',
          ratingValue: 'Extreme'
        }
      }
    };
  },
  computed: {
    likelihoodValue() {
      let localLikelihoodValue = '';

      if (this.$store.state.common.excursionDc) {
        const { riskOverall } = this.$store.state.common.excursionDc;

        if (riskOverall) {
          if (this.riskRatingRefname === 'inherent') {
            localLikelihoodValue = riskOverall.inherentLikelihood;
          } else {
            localLikelihoodValue = riskOverall.likelihood;
          }
        }
      }

      return localLikelihoodValue;
    },

    consequenceValue() {
      let localConsequenceValue = '';

      if (this.$store.state.common.excursionDc) {
        const { riskOverall } = this.$store.state.common.excursionDc;

        if (riskOverall) {
          if (this.riskRatingRefname === 'inherent') {
            localConsequenceValue = riskOverall.inherentConsequence;
          } else {
            localConsequenceValue = riskOverall.consequence;
          }
        }
      }

      return localConsequenceValue;
    },

    ratingLetter() {
      let localRatingLetter = '';

      if (this.$store.state.common.excursionDc) {
        const { riskOverall } = this.$store.state.common.excursionDc;

        if (riskOverall) {
          if (this.riskRatingRefname === 'inherent') {
            localRatingLetter = riskOverall.inherentRiskRating;
          } else {
            localRatingLetter = riskOverall['risk-rating'];
          }
        }
      }

      return localRatingLetter;
    },

    ratingValue() {
      let localRatingValue = '';
      const riskRatingTemplate = this.riskRatingTemplateHash[this.ratingLetter];

      if (riskRatingTemplate) {
        localRatingValue = riskRatingTemplate.ratingValue;
      }

      return localRatingValue;
    },

    ratingBgColor() {
      let bgColor = '';
      const riskRatingTemplate = this.riskRatingTemplateHash[this.ratingLetter];

      if (riskRatingTemplate) {
        bgColor = riskRatingTemplate.bgColor;
      }

      return bgColor;
    },

    ratingTextColor() {
      let textColor = '';
      const riskRatingTemplate = this.riskRatingTemplateHash[this.ratingLetter];

      if (riskRatingTemplate) {
        textColor = riskRatingTemplate.textColor;
      }

      return textColor;
    },

    tooltipBubbleTextDisplayed() {
      return typeof this.tooltipBubbleText !== 'undefined' && this.tooltipBubbleText !== '';
    }
  }
};
</script>
<style scoped>
.confirmation-info-text {
  color: rgb(0, 0, 0, 0.6);
  font-size: 14px;
}

.confirmation-info-text .v-icon {
  padding-bottom: 2px;
  font-size: 14px;
  margin-right: 3px;
}
.link-primary {
  color: rgb(var(--v-theme-primary));
}
</style>
